var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('div',{staticClass:"hero-banner"},[_c('img',{attrs:{"src":"images/banner.webp","alt":"","title":""}}),_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"animated-title"},[_vm._v("BRAVESTARCV")])])])])
}]

export { render, staticRenderFns }